const Products = {
  state: {},
  getters: {},
  actions: {},
  mutations: {}
}

export default Products



// WEBPACK FOOTER //
// ./src/store/modules/products.js